import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Menu from '@material-ui/core/Menu';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ButtonList from './ButtonList';

import './Card.scss';

const makeKey = (d, i) => i.toString();

const GrbCard = (props) => {
  const {
    icon: Icon,
    title,
    subheader,
    className,
    id,
    renderMenu,
    object,
    buttons,
    renderButtons,
    renderActionMessage,
    selected,
    onSelect,
    newlyCreated,
    disabled,
    description,
    children,
    ...rest
  } = props;

  // Menu
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = onSelect ? () => onSelect(object) : undefined;
  return (
    <React.Fragment>
      <Card
        className={classnames('grb-card',
          className,
          selected && 'grb-card-selected',
          newlyCreated && 'grb-card-newly-created',
          disabled && 'grb-card-disabled')}
        elevation={4}
        onClick={handleSelect}
        id={id}
      >
        <CardHeader
          avatar={
            Icon ? <Icon /> : <span />
          }
          action={(
            renderMenu ? (
              <IconButton aria-label="settings" onClick={handleMenuClick}>
                <MoreVertIcon />
              </IconButton>
            ) : (
              <span />
            )
          )}
          title={title}
          subheader={subheader}
        />
        {description && (
          <div className="grb-card-description">
            {description.split('\n').map((d, i) => (
              <Typography variant="body2" key={makeKey(d, i)}>{d}</Typography>
            ))}
          </div>
        )}
        <CardContent>
          <ul>
            {children}
          </ul>
        </CardContent>
        {((!!buttons && !!buttons.length) || !!renderButtons || !!renderActionMessage) && (
          <CardActions disableSpacing>
            {!!renderActionMessage && (
              <React.Fragment>
                <div className="grb-card-action-message">
                  {renderActionMessage({ ...rest, object })}
                </div>
                <div style={{ flex: '1 1 auto' }} />
              </React.Fragment>
            )}
            <ButtonList buttons={buttons} renderButtons={renderButtons} object={object} {...rest} />
          </CardActions>
        )}
      </Card>
      {/* Menu */}
      {menuOpen && (
        <Menu
          id={id ? `${id}-menu` : 'card-menu'}
          anchorEl={anchorEl}
          keepMounted
          open={menuOpen}
          onClose={handleMenuClose}
        >
          {renderMenu({ ...rest, object })}
        </Menu>
      )}
    </React.Fragment>
  );
};

GrbCard.propTypes = {
  title: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  buttons: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
    label: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
    'aria-label': PropTypes.string,
    onClick: PropTypes.func,
    render: PropTypes.func,
  })),
  object: PropTypes.shape({}),
  renderButtons: PropTypes.func,
  renderMenu: PropTypes.func,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  renderActionMessage: PropTypes.func,
  newlyCreated: PropTypes.bool,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

GrbCard.defaultProps = {
  object: undefined,
  subheader: undefined,
  className: undefined,
  id: undefined,
  icon: undefined,
  buttons: [],
  renderMenu: undefined,
  renderButtons: undefined,
  selected: undefined,
  onSelect: undefined,
  renderActionMessage: undefined,
  newlyCreated: false,
  description: undefined,
  disabled: false,
  children: undefined,
};

export default GrbCard;
